module.exports = __webpack_public_path__ + "img/banner.e427808b.png";